module.exports = __webpack_public_path__ + "img/6.d8e4b39f.jpg";